export const SET_EVENTS_DATA = 'SET_EVENTS_DATA';